import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SystemSiteService } from 'app/services/system-site.service';
import { Subscription } from 'rxjs';
import * as moment from 'moment';

declare interface Table_With_Checkboxes {
  id?: number;
  check: boolean;
  product_name: string;
  type: string;
  qty?: number;
  price: string;
  amount?: string;
}
declare interface TableData2 {
  headerRow: string[];
  dataRows: Table_With_Checkboxes[];
}


@Component({
  selector: 'app-system-status',
  templateUrl: './system-status.component.html',
  styleUrls: ['./system-status.component.scss']
})


export class SystemStatusComponent {
  systemStatusSubscription: Subscription = null;
  systemNotificationSubscription: Subscription = null;
  Data: any;
  notificationData: any;
  public tableData2: TableData2;
  loading = false;

  constructor(private modalService: NgbModal, private systemSiteService: SystemSiteService) { }

  ngOnInit(): void {

    this.LoadData();

  }

  LoadData() {
    this.systemStatusSubscription = this.systemSiteService.get_system_status().subscribe({
      next: (data) => {
        console.log(data.result_data)
        this.Data = data.result_data;
        this.loading = false;
      },
      error: error => { console.log(error) },
    })


    this.systemNotificationSubscription = this.systemSiteService.get_system_notifications().subscribe({
      next: (data) => {
        console.log(data.result_data)
        this.notificationData = data.result_data;
        this.loading = false;
      },
      error: error => { console.log(error) },
    })

  }

  ngOnDestroy(): void {
    if (this.systemStatusSubscription)
      this.systemStatusSubscription.unsubscribe();
    if (this.systemNotificationSubscription)
      this.systemNotificationSubscription.unsubscribe();
  }



  showTooltip(evt, data) {
    console.log("show")
    let tooltip = document.getElementById("tooltip");
    if (data.status.toUpperCase() === 'NORMAL') {
      let innerHTML  = "<h6>" + data.status.toUpperCase() + "</h6>";
      innerHTML += "<p>Nothing to report</p>";
      tooltip.innerHTML = innerHTML;
      
      tooltip.style.textAlign = "center";
      tooltip.style.width = "250px"
      tooltip.style.height = "75px"
    } else {
      var tooltip_height = 100
      tooltip.style.width = "250px"
      tooltip.style.height = "100px"
      let innerHTML = "<h6>" + "Incident" + "</h6>"
      for (let record of data.record) {
        innerHTML += "<p>Started @ " + (moment(record.incident_date)).format('DD MMM YYYY HH:mm') + "  " + record.details + "</p>";
        if (record.resolve_date != null)
          {
            innerHTML += "<p>Resolved @ " + (moment(record.resolve_date)).format('DD MMM YYYY HH:mm') + "  " + record.resolve_details + "</p>";
            tooltip_height = tooltip_height + 50
          }
      }
      tooltip.style.textAlign = "left";
      tooltip.innerHTML = innerHTML;
      tooltip.style.height = tooltip_height + "px"
    };


    tooltip.style.color = 'black'
    tooltip.style.display = "block";
    tooltip.style.backgroundColor = "white";

    tooltip.style.padding = "5px 5px 5px 5px";
    tooltip.style.borderRadius = "6px";

    tooltip.style.position = "absolute"

    tooltip.style.borderWidth = "1px"
    tooltip.style.borderColor = "black"
    tooltip.style.borderBottom = "1px dotted black"
    tooltip.style.borderTop = "1px dotted black"
    tooltip.style.borderLeft = "1px dotted black"
    tooltip.style.borderRight = "1px dotted black"

    console.log(evt.pageX + "  " + evt.pageY)

    tooltip.style.left = (evt.pageX - 250) + 'px';
    tooltip.style.top = (evt.pageY - 50) + 'px';
  }

  hideTooltip() {
    console.log("hide")
    var tooltip = document.getElementById("tooltip");
    tooltip.style.display = "none";
  }


}
